import Table from '../table/Table';

export function getLastVisibleColumnIndex(table: Table | null): number | undefined {
  const visibleColumnIndexes = table?.visibleColumnIndexes ?? [];

  return visibleColumnIndexes[visibleColumnIndexes.length - 1];
}
